import React, { useMemo, useEffect, useCallback } from 'react'
import { useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import PageLayout from '@/components/PageLayout'
import Header from '@/components/Header'
import Back from '@/components/Back/index'
import { useCurrencySelection } from '@/contexts/AppStateContext'
import Ripple from '@/components/Ripple'
export default React.memo(function SelectNetwork() {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const { selectedCurrency, actions } = useCurrencySelection()

  // 检查是否有选中的币种，如果没有则跳转到选择币种页面
  useEffect(() => {
    if (!selectedCurrency) {
      console.warn('未找到选中的币种信息，请先选择币种')
      navigate('/recharge/select-currency', { replace: true })
    }
  }, [selectedCurrency, navigate])


  const handleSelectNetwork = useCallback((currentNetwork: any) => {
    // 使用AppStateContext存储选中的网络信息
    actions.setCurrentNetwork({
      chainId: currentNetwork.chain_id || '',
      chainName: currentNetwork.chainName || currentNetwork.symbol || '',
      symbol: currentNetwork.symbol || ''
    })
    // 选择网络后跳转到货币详情页面，使用 replace 避免重复历史记录
    navigate(`/recharge/currency-details`, { replace: true })
  }, [actions, navigate])

  // 直接渲染网络列表
  const NetworkList = useMemo(
    () => selectedCurrency?.chainList.map((item, index) => (
      <Ripple key={index} className='rounded-2 w-full'>
        <div
          key={index}
          onClick={() => handleSelectNetwork(item)}
          className="w-full my-4 "
        >
          <div className="flex items-center">
            <div className="w-7 h-7 rounded-full mr-3 bg-gray-100 flex items-center justify-center">
              <img className='w-full w-full object-cover' src={item.icon_url} alt={item.symbol} />
            </div>
            <div className="flex-1 text-left">
              <div className="text-base font-medium text-gray-900 mb-1">
                {item.symbol}
              </div>
              <div className="text-xs text-[#989697] mb-1">
                {t('最小充币额')}:10 {selectedCurrency?.symbol}
              </div>
              <div className="text-xs text-[#989697]">
                {t('预计约X分钟内到账', { minutes: 7 })}
              </div>
            </div>
          </div>
        </div>
      </Ripple>
    )),
    [selectedCurrency, handleSelectNetwork, t]
  )

  return (
    <PageLayout>
      <Header
        leftChildren={<Back />}
        centerChildren={
          <div className="text-3.75 font-medium text-black truncate flex items-center">
            <img className='w-6 h-6 mr-2' src={selectedCurrency?.icon} />{t('选择网络')}
          </div>
        }
      ></Header>
      <div className="bg-[#F3F3F3] rounded-lg p-4 mx-6 my-6 flex">
        <div className='w-4 h-4 bg-black text-2.5 rounded-full mr-3 text-white flex justify-center items-center'>i</div>
        <div className="flex-1">
          <div className="text-sm font-normal text-black mb-1">
            {t('不清楚如何选择正确的充币网络')}
          </div>
          <div className="text-xs text-black mb-2">
            {t('请选择与您发送资产平台上一致的网络进行充币')}
          </div>
          <div
            className="flex items-center font-bold text-black text-xs"
          >
            {t('了解更多')}
            <img className='ml-2' src="/icon/more.svg" alt="" />
          </div>
        </div>
      </div>

      {/* Network List */}
      <div className="px-6 pb-8">
        {NetworkList}
      </div>
    </PageLayout>
  )
})